export default __webpack_public_path__ + "static/media/Cart_Error.83718f75.svg";